import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import ParticleField from "@/components/ParticleField";
import UniverseGraph from "@/components/UniverseGraph";
import { useProjects } from "@/lib/useProjects";

export default function UniversePage() {
  const { projects } = useProjects();
  return (
    <div>
      <SEO title="The ImJove Universe — Explore the Ecosystem" description="An interactive map of the entire ImJove Tech technology ecosystem. Drag, zoom, and explore every product." />
      <section className="relative overflow-hidden pt-32 pb-8">
        <ParticleField className="absolute inset-0 z-0" density={30} />
        <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal>
            <p className="font-mono2 text-xs uppercase tracking-brand text-gold-light">The ImJove Universe</p>
            <h1 className="mt-4 max-w-3xl font-display text-5xl font-bold tracking-tighter text-white sm:text-6xl">
              One ecosystem. <span className="text-gold-gradient">Infinitely connected.</span>
            </h1>
            <p className="mt-5 max-w-2xl font-body text-white/55">
              ImJove Tech sits at the center. Drag to move, scroll to zoom, and click any product to explore it.
            </p>
          </Reveal>
        </div>
      </section>
      <section className="pb-24">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal>{projects.length > 0 && <UniverseGraph projects={projects} height={680} />}</Reveal>
        </div>
      </section>
    </div>
  );
}
